import React, { memo, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import { mdiBookshelf } from '@mdi/js';
import Icon from '@mdi/react';
import { scrollToTop } from '../../../shared/utils/smartutils';
import OptionsSelection from '../../../shared/components/form/OptionsSelection';

const InfoCardsSubjects = (props) => {
  const { t, data, meta, onChangeData, employeeListBySubject, rooms } = props;
  const [detailsData, setDetailsData] = useState([]);

  const onChangeField = (value, field, index, item) => {
    const updatedDetailsData = [...detailsData];
    const updatedItem = { ...item };
    updatedItem[field] = value;
    updatedDetailsData[index] = updatedItem;
    onChangeData(updatedDetailsData);
  };

  const foundList = (id) => {
    return employeeListBySubject.find((item) => item.id === id);
  };

  useEffect(() => {
    setDetailsData(data);
  }, [data]);

  return (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <div className="dynamic-card-form-container">
        <div className="wrapper-card">
          {detailsData.length
            ? detailsData.map((item, index) => (
                <div key={item.subject.name} className="card-form-container">
                  <div
                    className={`card-form-body ${
                      item.professor && item.room ? 'complete' : 'un-complete'
                    }`}
                  >
                    <div className="card-form-icon-header">
                      <Icon path={mdiBookshelf} size={1} />
                    </div>
                    <div className="card-form-body-content">
                      <div className="input-group">
                        <span className="label">{t('general.discipline')}</span>
                        <input
                          name={item.subject.name}
                          type="text"
                          value={item.subject.name}
                          readOnly
                        />
                      </div>
                      <div className="input-group">
                        <span className="label">{t('general.teacher')}</span>
                        <OptionsSelection
                          name="teacher"
                          list={
                            foundList(item.subject.id)
                              ? foundList(item.subject.id).item
                              : []
                          }
                          selected={
                            item.professor ? item.professor : { value: 0 }
                          }
                          handleChange={(value) =>
                            onChangeField(value, 'professor', index, item)
                          }
                          maxWidth={190}
                        />
                      </div>
                      <div className="input-group">
                        <span className="label">{t('general.main-room')}</span>
                        <OptionsSelection
                          name="room"
                          list={rooms}
                          maxWidth={190}
                          selected={item.room ? item.room : { value: 0 }}
                          handleChange={(value) =>
                            onChangeField(value, 'room', index, item)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : null}
        </div>
      </div>
      {meta.touched && meta.error && (
        <span className="form__form-group-error">
          {meta.error}
          {scrollToTop()}
        </span>
      )}
    </div>
  );
};

InfoCardsSubjects.propTypes = {
  t: PropTypes.func.isRequired,
  onChangeData: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  employeeListBySubject: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  rooms: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

InfoCardsSubjects.defaultProps = {
  data: [],
  employeeListBySubject: [],
  meta: {
    touched: false,
    error: '',
  },
};

export default withTranslation('common')(memo(InfoCardsSubjects));
